import React, { useEffect, useRef } from 'react'
import { connect } from "react-redux";
import { useNavigate, generatePath } from "react-router-dom";
import {
  fetchRateAdminAdvanceRate,
  initializeRateAdminAdvanceRateScreen,
  exportRateAdminAdvanceRate,
  saveAdvanceRateTableState,
  deleteRateAdminAdvanceRate,
  setDeleteConfirmationPopupVisibility,
} from "../../../redux/actions/RateAdmin/rateadminAdvanceRate";
import {
  fetchRateAdminRatesById,
  fetchRateAdminRatesRateAdjDetails,
  createRateAdminRateAdjustment,
  TestRateAdminRates,
  fetchExternalNetworkDD,
  fetchExternalRateTest,
  clearExternalRateTest,
  editRateAdminRates,
  fetchRevenuePreview,
} from "../../../redux/actions/RateAdmin/rateadminRates";
import {
  fetchLocationDD
} from "../../../redux/actions/location";
import {
  fetchVehicleCategoryDD
} from "../../../redux/actions/vehicles/vehicleCategory";
import {
  fetchRateAdminRateCodeDD
} from "../../../redux/actions/RateAdmin/rateadminRateCode";
import {
  fetchRateAdminNetworkDD,
  fetchRateAdminRateOptionsDD,
} from "../../../redux/actions/RateAdmin/rateadminRates";
import RateAdminAdvanceRate from '../../../component/RateAdmin/RateAdminAdvanceRate';
import { loadingShow } from '../../../services/PostAPI';
import { APP_URLS } from '../../../utils/constant';
import { FILTER } from '../../../services/common/urlService';
import { DATE_STRATEGY, formatDate } from '../../../utils/date';

function RateAdminAdvanceRateScreen(props) {
  const {
    fetchRateAdminAdvanceRate,
    initRateAdminAdvanceRateScreen,
    showPageLevelLoader,
    rateAdminAdvanceRateListview,
    paginationInfo,
    screenPermissions,
    exportRateAdminAdvanceRate,
    isRateAdminAdvanceRateExportError,
    isRateAdminAdvanceRateExportSuccess,
    isLoading,
    isPageLevelError,
    savedTableState,
    saveAdvanceRateTableState,
    deleteRateAdminAdvanceRate,
    setDeleteConfirmationPopupVisibility,
    shouldOpenDeleteConfirmationPopup,
    isRateAdminAdvanceRateDeleteSuccess,
    isRateAdminAdvanceRateDeleteError,
    fetchRateAdminRatesById,
    formFieldValueMap,
    isRateAdminRatesDetailSuccess,
    fetchLocationDD,
    fetchVehicleCategoryDD,
    locationDD,
    vehicleCategoryDD,
    // Additional props for inline view functionality
    fetchRateAdminRateCodeDD,
    fetchRateAdminNetworkDD,
    fetchRateAdminRateOptionsDD,
    RateCodeDD,
    RateOptionsDD,
    RateNetworkDD,
    fetchRateAdminRatesRateAdjDetails,
    createRateAdminRateAdjustment,
    TestRateAdminRates,
    fetchExternalNetworkDD,
    fetchExternalRateTest,
    clearExternalRateTest,
    rateAdjustmentlist,
    RateTest,
    ExternalNetworkDD,
    ExternalRateTest,
    isExternalRateTestSuccess,
    isExternalRateTestError,
    isRateAdminRateAdjSuccess,
    isRateAdminRateAdjListSuccess,
    editRateAdminRates,
    isRateAdminRatesEditSuccess,
    isRateAdminRatesEditError,
    fetchRevenuePreview,
    revenuePreviewData,
    isRevenuePreviewSuccess,
  } = props;

  const navigate = useNavigate();

  // Use ref to capture initial savedTableState to avoid closure issues
  const initialSavedState = useRef(savedTableState);

  const buildFetchParamsFromSavedState = (state) => {
    if (!state) return null;
    
    // Helper to check if a string looks like an ISO date
    const isISODateString = (str) => {
      if (typeof str !== 'string') return false;
      return /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}/.test(str);
    };
    
    // Helper to format date values to YYYY-MM-DD
    const formatFilterValue = (value) => {
      if (value instanceof Date) {
        return formatDate(value, DATE_STRATEGY.DATE_ISO);
      }
      if (isISODateString(value)) {
        return formatDate(new Date(value), DATE_STRATEGY.DATE_ISO);
      }
      return value;
    };
    
    // Build filter params in the format expected by the API
    const filters = [];
    if (state.filters) {
      Object.keys(state.filters).forEach(key => {
        if (key !== 'global' && state.filters[key]?.value !== null && state.filters[key]?.value !== undefined) {
          const filterValue = state.filters[key].value;
          filters.push({
            filterField: state.filters[key].filterKey || key,
            matchStrategy: state.filters[key].matchStrategy || FILTER.MATCH_STRATEGY.CONTAINS,
            query: formatFilterValue(filterValue)
          });
        }
      });
    }
    
    return {
      sortField: state.sortField || 'id',
      sortOrder: state.sortOrder,
      pageNumber: state.page || 0,
      pageSize: state.rows || 10,
      filters: filters.length > 0 ? filters : undefined,
      userId: localStorage.getItem("userId")
    };
  };

  useEffect(() => {
    initRateAdminAdvanceRateScreen();
    
    // Fetch dropdowns for row expansion inline view
    fetchLocationDD();
    fetchVehicleCategoryDD();
    fetchRateAdminRateCodeDD();
    fetchRateAdminNetworkDD();
    fetchRateAdminRateOptionsDD();
    
    // Fetch with saved state params if available, otherwise use defaults
    const savedParams = buildFetchParamsFromSavedState(initialSavedState.current);
    
    if (savedParams) {
      fetchRateAdminAdvanceRate(savedParams);
    } else {
      fetchRateAdminAdvanceRate({ sortField: 'id', userId: localStorage.getItem("userId") });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const loadLazyData = (props) => {
    let newPayload = {
      ...props,
      userId: localStorage.getItem("userId")
    };
    fetchRateAdminAdvanceRate(newPayload);
  };

  const handleTableStateChange = (tableState) => {
    saveAdvanceRateTableState(tableState);
  };

  const handleCreateRateAdminAdvanceRate = () => {
    navigate(APP_URLS.RATEADMIN_ADVANCERATE.CREATE);
  };

  const editRateAdminAdvanceRateRoute = () => {
    navigate(APP_URLS.RATEADMIN_ADVANCERATE.UPDATE);
  };

  const viewRateAdminAdvanceRateRoute = (id) => {
    const path = generatePath(APP_URLS.RATEADMIN_ADVANCERATE.VIEW, { id });
    navigate(path);
  };

  // Build columns with dropdown options for filters
  let nColumns = rateAdminAdvanceRateListview?.columns;
  if (nColumns && nColumns.length > 0) {
    let locDD = [];
    let cateDD = [];
    locationDD?.map(item => (
      locDD.push({ label: item.name, value: item.id })
    ))
    vehicleCategoryDD?.map(item => (
      cateDD.push({ label: item.name, value: item.id })
    ))
    nColumns = nColumns?.map(item => ({
      ...item,
      ...(item.dataKey === "locationTitle" ? { extraProps: { ...item.extraProps, options: locDD } } : {}),
      ...(item.dataKey === "categoryTitle" ? { extraProps: { ...item.extraProps, options: cateDD } } : {}),
    }));
  }

  const rateAdminAdvanceRate = {
    handleCreateRateAdminAdvanceRate,
    editRateAdminAdvanceRateRoute,
    exportRateAdminAdvanceRate,
    isRateAdminAdvanceRateExportError,
    isRateAdminAdvanceRateExportSuccess,
    deleteRateAdminAdvanceRate,
    viewRateAdminAdvanceRateRoute,
    screenPermissions,
    fetchRateAdminAdvanceRates: loadLazyData,
    tableData: {
      columns: nColumns,
      rows: rateAdminAdvanceRateListview?.rows,
    },
    paginationInfo: {
      pageSize: paginationInfo?.pageSize,
      pageNumber: paginationInfo?.pageNumber,
      totalPages: paginationInfo?.totalPages,
      totalRecords: paginationInfo?.totalRecords,
    },
    isLoading,
    isPageLevelError,
    savedTableState,
    onTableStateChange: handleTableStateChange,
    shouldOpenDeleteConfirmationPopup,
    setDeleteConfirmationPopupVisibility,
    isRateAdminAdvanceRateDeleteSuccess,
    isRateAdminAdvanceRateDeleteError,
    fetchRateAdminRatesById,
    formFieldValueMap,
    isRateAdminRatesDetailSuccess,
    locationDD,
    vehicleCategoryDD,
    // Additional props for inline view functionality
    RateCodeDD,
    RateOptionsDD,
    RateNetworkDD,
    fetchRateAdminRatesRateAdjDetails,
    createRateAdminRateAdjustment,
    TestRateAdminRates,
    fetchExternalNetworkDD,
    fetchExternalRateTest,
    clearExternalRateTest,
    rateAdjustmentlist,
    RateTest,
    ExternalNetworkDD,
    ExternalRateTest,
    isExternalRateTestSuccess,
    isExternalRateTestError,
    isRateAdminRateAdjSuccess,
    isRateAdminRateAdjListSuccess,
    editRateAdminRates,
    isRateAdminRatesEditSuccess,
    isRateAdminRatesEditError,
    fetchRevenuePreview,
    revenuePreviewData,
    isRevenuePreviewSuccess,
  };

  if (showPageLevelLoader) {
    loadingShow("block");
    return null;
  }
  loadingShow("none");

  return (
    <div>
      <RateAdminAdvanceRate
        {...rateAdminAdvanceRate}
      />
    </div>
  );
}

const mapDispatchToProps = (dispatch) => {
  return {
    initRateAdminAdvanceRateScreen: () => dispatch(initializeRateAdminAdvanceRateScreen()),
    fetchRateAdminAdvanceRate: (payload) => dispatch(fetchRateAdminAdvanceRate(payload)),
    exportRateAdminAdvanceRate: (payload) => dispatch(exportRateAdminAdvanceRate(payload)),
    saveAdvanceRateTableState: (payload) => dispatch(saveAdvanceRateTableState(payload)),
    deleteRateAdminAdvanceRate: (payload) => dispatch(deleteRateAdminAdvanceRate(payload)),
    setDeleteConfirmationPopupVisibility: (payload) => dispatch(setDeleteConfirmationPopupVisibility(payload)),
    fetchRateAdminRatesById: (payload) => dispatch(fetchRateAdminRatesById(payload)),
    fetchLocationDD: (payload) => dispatch(fetchLocationDD(payload)),
    fetchVehicleCategoryDD: (payload) => dispatch(fetchVehicleCategoryDD(payload)),
    // Additional dispatch actions for inline view
    fetchRateAdminRateCodeDD: (payload) => dispatch(fetchRateAdminRateCodeDD(payload)),
    fetchRateAdminNetworkDD: (payload) => dispatch(fetchRateAdminNetworkDD(payload)),
    fetchRateAdminRateOptionsDD: (payload) => dispatch(fetchRateAdminRateOptionsDD(payload)),
    fetchRateAdminRatesRateAdjDetails: (payload) => dispatch(fetchRateAdminRatesRateAdjDetails(payload)),
    createRateAdminRateAdjustment: (payload) => dispatch(createRateAdminRateAdjustment(payload)),
    TestRateAdminRates: (payload) => dispatch(TestRateAdminRates(payload)),
    fetchExternalNetworkDD: (payload) => dispatch(fetchExternalNetworkDD(payload)),
    fetchExternalRateTest: (payload) => dispatch(fetchExternalRateTest(payload)),
    clearExternalRateTest: () => dispatch(clearExternalRateTest()),
    editRateAdminRates: (payload) => dispatch(editRateAdminRates(payload)),
    fetchRevenuePreview: (payload) => dispatch(fetchRevenuePreview(payload)),
  };
};

const mapStateToProps = (state, ownProps) => {
  return {
    isRateAdminAdvanceRateCreateSuccess: selectFromRateAdminAdvanceRateReducer(
      state,
      "isRateAdminAdvanceRateCreateSuccess"
    ),
    rateAdminAdvanceRateListview: selectFromRateAdminAdvanceRateReducer(
      state,
      "rateAdminAdvanceRateListview"
    ),
    showPageLevelLoader: selectFromRateAdminAdvanceRateReducer(
      state,
      "showPageLevelLoader"
    ),
    paginationInfo: selectFromRateAdminAdvanceRateReducer(
      state,
      "paginationInfo"
    ),
    isPageLevelError: selectFromRateAdminAdvanceRateReducer(
      state,
      "isPageLevelError"
    ),
    isFetchingGridData: selectFromRateAdminAdvanceRateReducer(
      state,
      "isFetchingGridData"
    ),
    isRateAdminAdvanceRateExportError: selectFromRateAdminAdvanceRateReducer(
      state,
      "isRateAdminAdvanceRateExportError"
    ),
    isRateAdminAdvanceRateExportSuccess: selectFromRateAdminAdvanceRateReducer(
      state,
      "isRateAdminAdvanceRateExportSuccess"
    ),
    savedTableState: selectFromRateAdminAdvanceRateReducer(
      state,
      "savedTableState"
    ),
    isLoading: selectFromRateAdminAdvanceRateReducer(
      state,
      "isLoading"
    ),
    shouldOpenDeleteConfirmationPopup: selectFromRateAdminAdvanceRateReducer(
      state,
      "shouldOpenDeleteConfirmationPopup"
    ),
    isRateAdminAdvanceRateDeleteSuccess: selectFromRateAdminAdvanceRateReducer(
      state,
      "isRateAdminAdvanceRateDeleteSuccess"
    ),
    isRateAdminAdvanceRateDeleteError: selectFromRateAdminAdvanceRateReducer(
      state,
      "isRateAdminAdvanceRateDeleteError"
    ),
    formFieldValueMap: selectFromRateAdminRatesReducer(
      state,
      "formFieldValueMap"
    ),
    isRateAdminRatesDetailSuccess: selectFromRateAdminRatesReducer(
      state,
      "isRateAdminRatesDetailSuccess"
    ),
    // Additional state for inline view
    rateAdjustmentlist: selectFromRateAdminRatesReducer(
      state,
      "rateAdjustmentlist"
    ),
    RateTest: selectFromRateAdminRatesReducer(state, "RateTest"),
    ExternalNetworkDD: selectFromRateAdminRatesReducer(state, "ExternalNetworkDD"),
    ExternalRateTest: selectFromRateAdminRatesReducer(state, "ExternalRateTest"),
    isExternalRateTestSuccess: selectFromRateAdminRatesReducer(state, "isExternalRateTestSuccess"),
    isExternalRateTestError: selectFromRateAdminRatesReducer(state, "isExternalRateTestError"),
    isRateAdminRateAdjSuccess: selectFromRateAdminRatesReducer(
      state,
      "isRateAdminRateAdjSuccess"
    ),
    isRateAdminRateAdjListSuccess: selectFromRateAdminRatesReducer(
      state,
      "isRateAdminRateAdjListSuccess"
    ),
    isRateAdminRatesEditSuccess: selectFromRateAdminRatesReducer(
      state,
      "isRateAdminRatesEditSuccess"
    ),
    isRateAdminRatesEditError: selectFromRateAdminRatesReducer(
      state,
      "isRateAdminRatesEditError"
    ),
    revenuePreviewData: selectFromRateAdminRatesReducer(
      state,
      "revenuePreviewData"
    ),
    isRevenuePreviewSuccess: selectFromRateAdminRatesReducer(
      state,
      "isRevenuePreviewSuccess"
    ),
    RateOptionsDD: selectFromRateAdminRatesReducer(
      state,
      "RateOptionsDD"
    ),
    RateNetworkDD: selectFromRateAdminRatesReducer(
      state,
      "RateNetworkDD"
    ),
    RateCodeDD: selectFromRateCodeReducer(
      state,
      "RateCodeDD"
    ),
    locationDD: selectFromLocationReducer(
      state,
      "locationDD"
    ),
    vehicleCategoryDD: selectFromVehicleCategoryReducer(
      state,
      "vehicleCategoryDD"
    ),
    ...ownProps,
  };
};

const selectFromRateAdminAdvanceRateReducer = (state, path) => {
  return selectRateAdminAdvanceRateReducer(state)[path];
};

const selectRateAdminAdvanceRateReducer = ({ rateadminAdvanceRateReducer }) => {
  return rateadminAdvanceRateReducer;
};

const selectFromRateAdminRatesReducer = (state, path) => {
  return selectRateAdminRatesReducer(state)[path];
};

const selectRateAdminRatesReducer = ({ rateadminRatesReducer }) => {
  return rateadminRatesReducer;
};

const selectFromLocationReducer = (state, path) => {
  return selectLocationReducer(state)[path];
};
const selectLocationReducer = ({ locationReducer }) => {
  return locationReducer;
};

const selectFromVehicleCategoryReducer = (state, path) => {
  return selectVehicleCategoryReducer(state)[path];
};
const selectVehicleCategoryReducer = ({ vehicleCategoryReducer }) => {
  return vehicleCategoryReducer;
};

const selectFromRateCodeReducer = (state, path) => {
  return selectRateCodeReducer(state)[path];
};
const selectRateCodeReducer = ({ rateadminRateCodeReducer }) => {
  return rateadminRateCodeReducer;
};

export default connect(mapStateToProps, mapDispatchToProps)(RateAdminAdvanceRateScreen);
